import { NotifyHelper } from "../../../helpers/toast";
import { objCrmSurveyFormQuestionDefine } from "../../action-types/crm-survey/ICrmSurveyFormQuestionActionTypes";
import { generateActionForKey, generateActions } from "../generateActions";



export const crmSurveyFormQuestionActions = {
    ...generateActions(objCrmSurveyFormQuestionDefine, "CRM_SURVEY_FORM_QUESTION"),
    ...generateActionForKey(objCrmSurveyFormQuestionDefine, "CRM_SURVEY_FORM_QUESTION",
        "LOAD_ERROR", (m: any) => NotifyHelper.Error(m)),
    ...generateActionForKey(objCrmSurveyFormQuestionDefine, "CRM_SURVEY_FORM_QUESTION",
        "CHANGE_SELECTED_IDS", (m: any) =>{}),
}